const rootClass = 'weet-components-input';
export { rootClass };
